import {Injectable} from "@angular/core";
import {ServerService} from "./ServerService";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class TunapayService  extends ServerService {
  constructor(http: HttpClient) {
    super(http);
  }

  crieSessao(guid: string) {
    return this.facaPost(`/tunapay/cartao/nova-sessao/${guid}`, {});
  }

  // NOVOS MÉTODOS PARA CARTEIRAS DIGITAIS
  async salveDadosTemporarios(dados: any) {
    return this.facaPost('/tunapay/carteiradigitais/dados/' + dados.guid, dados);
  }

  async atualizeDadosSessao(guid, dados: any){
    return this.facaPost(`/tunapay/carteiradigitais/dados/${guid}/sessaotuna`, dados);
  }

  async novaTentativaPagamento(guid: string){
    return this.facaPost( `/tunapay/carteiradigitais/dados/${guid}/novatentativa`, {});
  }

  async obtenhaDadosTemporarios(guid: string) {
    return this.obtenha(`/tunapay/carteiradigitais/dados/${guid}`, {});
  }

  async atualizeDadosCartao(guid: string, dados: any) {
    return this.facaPost(`/tunapay/carteiradigitais/dados/${guid}/cartao`, dados);
  }

  obtenhaUrlRedirect(guid: string ) {
    return this.obtenha('/tunapay/carteiradigitais/siteredirect/' + guid, {})
  }

  async atualizeTaxaNegociada(params: any){
    return this.facaPost('/tunapay/meucardapiopay/taxa/negociar', params)
  }

  async atualizeTaxaNegociadaPix(params: any){
    return this.facaPost('/tunapay/meucardapiopay/taxa/pix/negociar', params)
  }
}
